import './DurationPicker.css';
import { __ } from '@wordpress/i18n';
import { formatDuration } from '../utils/date-time';
import { useService } from '../hooks/useBookingComputed';
import { useBookingStore } from '../store/useBookingStore';

export function DurationPicker() {
	const { data: service } = useService();
	const selectedDuration = useBookingStore((state) => state.selectedDuration);
	const setSelectedDuration = useBookingStore(
		(state) => state.setSelectedDuration
	);

	if (!service?.flexibleDuration) {
		return null;
	}

	const blockSize = service.blockSize;
	const minDuration = service.minDuration ?? blockSize;
	const maxDuration = service.maxDuration ?? blockSize;

	// Generate duration options in block size increments
	const options = [];
	for (let d = minDuration; d <= maxDuration; d += blockSize) {
		options.push({
			value: d,
			label: formatDuration(d),
		});
	}

	return (
		<div className="gpb-booking-time-picker__duration-picker">
			<label htmlFor="gpb-duration-select">
				{__('Duration:', 'gp-bookings')}
			</label>
			<select
				id="gpb-duration-select"
				value={selectedDuration}
				onChange={(e) =>
					setSelectedDuration(parseInt(e.target.value, 10))
				}
			>
				{options.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
		</div>
	);
}
